import * as angular from 'angular';

import { ComponentDefinition, Identifier } from '../../models';
import { IStoreService } from '../../services';

class IdentifiersManagementStateController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    groupGuid: string;

    static $inject = ['$stateParams', 'storeService'];

    constructor(
        private _$stateParams: angular.ui.IStateParamsService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.groupGuid = this._$stateParams['groupGuid'];
    }

    onUpdate(updated: Identifier[]) {
        if (updated.length) {
            try {
                this._storeService.dispatchers().identifiers.forceInMemoryUpdate(updated, true);
                this._storeService.dispatchers().valueViewModels.getAll(true);
            } catch (e) {
                console.error(e);
            }
        }
    }
}

export const wtIdentifiersManagementState: ComponentDefinition = {
    componentId: 'wtIdentifiersManagementState',
    controller: IdentifiersManagementStateController,
    template: require('./identifiersManagementState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};